import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { InstallationsService } from '../../services/installations.service';

@Component({
  selector: 'app-limited-search',
  templateUrl: './limited-search.component.html',
  styleUrls: ['./limited-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LimitedSearchComponent {
  @Input() noResults: boolean;
  @Input() isLimited: boolean;

  constructor(public installationsService: InstallationsService) {}

  learnMore(e: MouseEvent): void {
    e.stopImmediatePropagation();
    e.stopPropagation();
    this.installationsService.isSearchInfoBox$.next(true);
  }
}
